export default (consult) => {
  if (consult.patAvatar) {
    return consult.patAvatar
  } else if (consult.patGender) {
    let sex = consult.patGender.toLowerCase();
    if (sex === 'm') return require(`../../static/img/pat.m.jpg`);
    else return require(`../../static/img/pat.f.jpg`);
  } else if (consult.compatGender) {
    let sex = consult.compatGender.toLowerCase();
    if (sex === 'm') return require(`../../static/img/pat.m.jpg`);
    else return require(`../../static/img/pat.f.jpg`);
  } else {
    return require('../../static/img/pat.m.jpg');
  }
}





// WEBPACK FOOTER //
// ./src/utils/patAva.js